import React from 'react';
import styles from './Footer.module.css';

/**
 * Footer component for the application
 * Displays copyright information and additional links
 */
const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.copyright}>
          &copy; {new Date().getFullYear()} Tracking Simulator v2
        </div>
        <div className={styles.links}>
          <a href="#" className={styles.link}>Privacy Policy</a>
          <a href="#" className={styles.link}>Terms of Service</a>
          <a href="#" className={styles.link}>Contact</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
